import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supplyServices } from "./supply.services";
import { SUPPLY_KEYS } from "./supply.keys";
import { CreateSupplyParams, UpdateSupplyParams } from "./supply.type";

export const useCreateSupply = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateSupplyParams) =>
      supplyServices.createSupply(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SUPPLY_KEYS.GET_SUPPLIES(),
        exact: false,
      });
    },
  });
};

export const useUpdateSupply = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateSupplyParams & { id: string }) =>
      supplyServices.updateSupply(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SUPPLY_KEYS.GET_SUPPLIES(),
        exact: false,
      });
    },
  });
};
export const useDeleteSupply = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: supplyServices.deleteSupply,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SUPPLY_KEYS.GET_SUPPLIES(),
        exact: false,
      });
    },
  });
};
